//import api from './api'
import { $sharedservice } from "@/services/Index";

export default {
  namespaced: true,
  state: {
    countries: [],
    timezones: [],
    states: [],
  },
  mutations: {
    SET_COUNTRIES(state, data) {
      state.countries = data;
    },
    SET_TIMEZONES(state, data) {
      state.timezones = data;
    },
    SET_STATES(state, data) {
      state.states = data;
    },
  },

  actions: {
    /* eslint-disable */
    async getCountries({ commit }) {
      try {
        const response = await $sharedservice.countryList();
        if (response.data) {
          commit("SET_COUNTRIES", response.data);
        }
      } catch (error) {}
    },

    /* eslint-disable */
    async getTimezones({ commit }) {
      try {
        const response = await $sharedservice.timezoneList();
        if (response.data) {
          commit("SET_TIMEZONES", response.data);
        }
      } catch (error) {}
    },

    /* eslint-disable */
    async getStates({ commit }, country) {
      try {
        const response = await $sharedservice.stateList(country);
        if (response.data) {
          commit("SET_STATES", response.data);
        }
      } catch (error) {}
    },

    async clearStates({ commit }) {
      commit("SET_STATES", []);
    },

    getData({ dispatch }) {
      dispatch("getCountries");
      dispatch("getTimezones");
    },
  },

  getters: {
    countries(state) {
      return state.countries;
    },
    timezones(state) {
      return state.timezones;
    },
    states(state) {
      return state.states;
    },
  },
};
